/**
 * Declarative scroll-reveal for website-builder sections — runtime twin of
 * main-frontend `src/components/WebsiteBuilder/sections/utils/reveal.ts`.
 * Keep the two files byte-equivalent in behavior.
 *
 * Sections opt in via a serialized `reveal` prop ("none" | "fade" | "rise",
 * undefined = "none" = no class = byte-identical rendering to before). The
 * motion is pure CSS (scroll-driven animation) gated behind BOTH
 * `prefers-reduced-motion: no-preference` AND
 * `@supports (animation-timeline: view())`, so unsupported browsers and
 * reduced-motion users get a fully visible, motionless section.
 *
 * `WB_REVEAL_CSS` is injected once as a constant <style> by the runtime
 * `PageWrapper` in `runtime/components/layout.tsx`.
 */

export type WBReveal = "none" | "fade" | "rise";

export const revealClass = (reveal?: WBReveal): string => {
  if (reveal === "fade") return "wb-reveal wb-reveal-fade";
  if (reveal === "rise") return "wb-reveal wb-reveal-rise";
  return "";
};

export const WB_REVEAL_CSS = `
@media (prefers-reduced-motion: no-preference) {
  @supports (animation-timeline: view()) {
    @keyframes wbRevealFade {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    @keyframes wbRevealRise {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }
    .wb-reveal {
      animation-duration: 1ms;
      animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
      animation-fill-mode: both;
      animation-timeline: view();
      animation-range: entry 0% entry 30%;
    }
    .wb-reveal-fade { animation-name: wbRevealFade; }
    .wb-reveal-rise { animation-name: wbRevealRise; }
  }
}
`;
